import type { StripPaymentMethod } from '@goldfishcode/kingmakerdata-api-sdk/libs/api/stripe/models';
import { createSlice } from '@reduxjs/toolkit';

import { getPaymentMethods } from './thunk';

export interface PaymentState {
  paymentMethods: StripPaymentMethod[];
  count: number;
  currentPage: number;
  loading: boolean;
}

const initialState: PaymentState = {
  paymentMethods: [],
  count: 0,
  currentPage: 1,
  loading: false,
};

const slice = createSlice({
  initialState: initialState,
  name: 'payment',
  reducers: {
    reset: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(getPaymentMethods.fulfilled, (state, action) => {
      state.paymentMethods = action.payload.data;
      state.count = action.payload.count;
      state.currentPage = action.payload.currentPage;
      state.loading = false;
    });
    builder.addCase(getPaymentMethods.pending, state => {
      state.loading = true;
    });
    builder.addCase(getPaymentMethods.rejected, state => {
      state.loading = false;
    });
  },
});

export const { actions: paymentActions, reducer: paymentReducer } = slice;
